import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import { SHOP_ROUTE, ADMIN_ROUTE, LOGIN_ROUTE, BASKET_ROUTE } from '../routes';
import { fetchBasket } from '../http/basketAPI';

const NavBar = () => {
    const { user, basket } = useContext(Context);
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        if (user.isAuth && basket) {
            fetchBasket()
                .then(data => {
                    if (basket) {
                        basket.setDevices(data.devices || []);
                        basket.setTotalCount(data.totalCount || 0);
                        basket.setTotalPrice(data.totalPrice || 0);
                    }
                })
                .catch(error => {
                    console.error('Ошибка загрузки корзины:', error);
                });
        }
    }, [user.isAuth]);

    const logOut = () => {
        localStorage.removeItem('token');
        user.setIsAuth(false);
        user.setUser({});
        if (basket) {
            basket.clearBasket();
        }
        setExpanded(false);
        navigate(SHOP_ROUTE);
    };

    const goToLanding = () => {
        window.location.href = '/';
        setExpanded(false);
    };

    const handleNavigate = (route) => {
        setExpanded(false);
        navigate(route);
    };

    return (
        <Navbar 
            bg="white" 
            variant="light" 
            expanded={expanded}
            className="shadow-sm py-3"
            style={{ 
                borderBottom: '2px solid #66d9ff',
                minHeight: '80px',
                position: 'sticky',
                top: 0,
                zIndex: 1000
            }}
        >
            <Container>
                {/* Кнопка "На главную" - только для ПК */}
                <Button 
                    onClick={goToLanding}
                    className="btn-pink me-3 d-none d-lg-inline-block"
                    style={{ 
                        backgroundColor: '#ff9ae9',
                        borderColor: '#ff9ae9',
                        color: 'white',
                        borderRadius: '25px',
                        padding: '8px 24px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#ff7ad5';
                        e.target.style.borderColor = '#ff7ad5';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#ff9ae9';
                        e.target.style.borderColor = '#ff9ae9';
                    }}
                >
                    На главную
                </Button>

                <NavLink 
                    style={{ 
                        color: 'black', 
                        textDecoration: 'none', 
                        fontWeight: 'bold',
                        fontSize: '1.2rem'
                    }} 
                    to={SHOP_ROUTE}
                    onClick={() => setExpanded(false)}
                >
                    В магазин
                </NavLink>

                {/* ПК версия - обычный хедер */}
                <Nav className="ms-auto d-none d-lg-flex" style={{ alignItems: 'center', gap: '10px' }}>
                    {user.isAuth ? (
                        <>
                            {user.isAdmin && (
                                <Button 
                                    variant="link" 
                                    className="text-dark text-decoration-none"
                                    onClick={() => navigate(ADMIN_ROUTE)}
                                    style={{ fontWeight: '500' }}
                                >
                                    Админ
                                </Button>
                            )}

                            <span className="text-dark">
                                {user.user?.email || 'Пользователь'}
                            </span>

                            <Button 
                                variant="link" 
                                className="text-dark text-decoration-none"
                                onClick={logOut}
                                style={{ fontWeight: '500' }}
                            >
                                Выйти
                            </Button>

                            <Button 
                                onClick={() => navigate(BASKET_ROUTE)}
                                className="btn-pink position-relative"
                                style={{ 
                                    backgroundColor: '#ff9ae9',
                                    borderColor: '#ff9ae9',
                                    color: 'white',
                                    borderRadius: '25px',
                                    padding: '8px 24px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#ff7ad5';
                                    e.target.style.borderColor = '#ff7ad5';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#ff9ae9';
                                    e.target.style.borderColor = '#ff9ae9';
                                }}
                            >
                                Корзина
                                <span className="position-relative d-inline-flex align-items-center">
                                    <svg 
                                        viewBox="0 0 24 24" 
                                        fill="none" 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="22" 
                                        height="22"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier"> 
                                            <path 
                                                d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z" 
                                                stroke="#ffffff" 
                                                strokeWidth="2" 
                                                strokeLinecap="round" 
                                                strokeLinejoin="round"
                                            ></path> 
                                        </g>
                                    </svg>
                                    {basket && basket.totalCount > 0 && (
                                        <span 
                                            className="position-absolute" 
                                            style={{
                                                top: '-10px',
                                                right: '-10px',
                                                backgroundColor: 'white',
                                                color: '#ff9ae9',
                                                borderRadius: '50%',
                                                width: '18px',
                                                height: '18px',
                                                fontSize: '11px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {basket.totalCount}
                                        </span>
                                    )}
                                </span>
                            </Button>
                        </>
                    ) : (
                        <Button 
                            variant="link" 
                            className="text-dark text-decoration-none"
                            onClick={() => navigate(LOGIN_ROUTE)}
                            style={{ fontWeight: '500' }}
                        >
                            Авторизация
                        </Button>
                    )}
                </Nav>

                {/* Мобильная версия - иконки корзины и бургер */}
                <div className="d-flex align-items-center ms-auto gap-2 d-lg-none">
                    <Button 
                        onClick={() => handleNavigate(BASKET_ROUTE)}
                        variant="link"
                        className="p-0 position-relative"
                        style={{ textDecoration: 'none' }}
                    >
                        <svg 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="28" 
                            height="28"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"> 
                                <path 
                                    d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z" 
                                    stroke="#000000" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                ></path> 
                            </g>
                        </svg>
                        {basket && basket.totalCount > 0 && (
                            <span 
                                className="position-absolute" 
                                style={{
                                    top: '-5px',
                                    right: '-5px',
                                    backgroundColor: '#ff9ae9',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    fontSize: '11px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold'
                                }}
                            >
                                {basket.totalCount}
                            </span>
                        )}
                    </Button>

                    <Button
                        variant="link"
                        className="p-0"
                        onClick={() => setExpanded(!expanded)}
                        style={{ textDecoration: 'none' }}
                    >
                        <svg 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="28" 
                            height="28"
                        >
                            {expanded ? (
                                <path 
                                    d="M6 6L18 18M6 18L18 6" 
                                    stroke="#000000" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            ) : (
                                <path 
                                    d="M4 6H20M4 12H20M4 18H20" 
                                    stroke="#000000" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            )}
                        </svg>
                    </Button>
                </div>

                {/* Мобильное выпадающее меню */}
                {expanded && (
                    <div 
                        className="d-lg-none"
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            backgroundColor: 'white',
                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                            borderBottom: '2px solid #66d9ff',
                            zIndex: 999,
                            padding: '20px'
                        }}
                    >
                        <div className="d-flex flex-column gap-2 align-items-center">
                            <Button 
                                variant="link" 
                                className="text-dark text-decoration-none"
                                onClick={goToLanding}
                                style={{ fontWeight: '500' }}
                            >
                                На главную
                            </Button>

                            {user.isAuth ? (
                                <>
                                    {user.isAdmin && (
                                        <Button 
                                            variant="link" 
                                            className="text-dark text-decoration-none"
                                            onClick={() => handleNavigate(ADMIN_ROUTE)}
                                            style={{ fontWeight: '500' }}
                                        >
                                            Админ
                                        </Button>
                                    )}
                                    
                                    <Button 
                                        variant="link" 
                                        className="text-dark text-decoration-none"
                                        onClick={logOut}
                                        style={{ fontWeight: '500' }}
                                    >
                                        Выйти
                                    </Button>
                                </>
                            ) : (
                                <Button 
                                    variant="link" 
                                    className="text-dark text-decoration-none"
                                    onClick={() => handleNavigate(LOGIN_ROUTE)}
                                    style={{ fontWeight: '500' }}
                                >
                                    Авторизация
                                </Button>
                            )}
                        </div>
                    </div>
                )}
            </Container>
        </Navbar>
    );
};

export default observer(NavBar);
